export default async function getCompetencesByArea() {
  // Permite cononcer los resultados por tipo de competencia por área
  const url =
    localStorage.getItem("endpoint") +
    "competencesbyarea/" +
    localStorage.getItem("id");

  try {
    const config = {
      method: "GET",
      headers: {},
    };
    const response = await fetch(url, config);
    const json = await response.json();
    return json;
  } catch (error) {
    console.log("Error" + error);
    return { payload: {} };
  }
}
